import React from 'react';
// Importer des icônes existantes
import "../../styles/ServiceSection.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useTranslation } from "react-i18next";
import "../../../i18n";

const ServiceSection = () => {
  const { t } = useTranslation();

  return (
    <div className='all'>
      <hr className="ite"></hr>
      <div className="features-container">
        <div className="feature">
          <div className="feature-icon">
            <i className="fas fa-rocket"></i>
          </div>
          <h5>{t('features.payment.title')}</h5>
          <p>{t('features.payment.description')}</p>
        </div>
        <div className="feature">
          <div className="feature-icon">
            <i className="fas fa-redo-alt"></i>
          </div>
          <h5>{t('features.receipt.title')}</h5>
          <p>{t('features.receipt.description')}</p>
        </div>
        <div className="feature">
          <div className="feature-icon">
            <i className="fas fa-store"></i>
          </div>
          <h5>{t('features.purchase.title')}</h5>
          <p>{t('features.purchase.description')}</p>
        </div>
      </div>
    </div>
  );
};
export default ServiceSection;
